import { Box, Grid, Typography } from "@mui/material"
import { flexRender } from "@tanstack/react-table"
import { DefaultColumnFilter } from "../ClpTableFilterTypes"
import { useTranslation } from "react-i18next"

const MoreFilters = (props) => {
  const { headerGroups } = props
  const { t } = useTranslation()

  return (
    <Box mt={3}>
      <Typography variant="h6" gutterBottom mb={1}>
        {t("global.advanced_search", "Advanced search")}:
      </Typography>
      <Grid container direction="row" alignItems="center" justifyContent="flex-start" spacing={2}>
        {headerGroups?.map((headerGroup) =>
          headerGroup.headers
            .filter(
              (x) =>
                !x.column.columnDef.meta?.hiddenFilter &&
                !x.column.columnDef.meta?.mainFilter &&
                x.column.columnDef.header
            )
            .map((header, index) => {
              return (
                header.column.getCanFilter() && (
                  <Grid xs={12} md={4} lg={3} xl={2} item key={index}>
                    {flexRender(header.column.columnDef?.meta?.filter ?? DefaultColumnFilter, {
                      column: header.column
                    })}
                  </Grid>
                )
              )
            })
        )}
      </Grid>
    </Box>
  )
}

export default MoreFilters
